import { languageFlags, languages } from "../../../constant/Languages";

export const MultiLangInputComponent = ({
  name,
  label,
  value = [],
  setFieldValue,
  error,
  touched,
  handleAdd,
  handleRemove,
  handleSelectLang,
}: any) => {
  const handleChange = (
    index: number,
    type: "language" | "text",
    val: string
  ) => {
    const updatedValue = value?.map((item: any, ind: number) =>
      ind === index ? { ...item, [type]: val } : item
    );
    setFieldValue(name, updatedValue);
  };

  return (
    <div key={name}>
      <label className="block mb-2 mt-3 text-xl font-bold text-darkgray font-roboto">
        {label}
      </label>
      <div className="bg-gray-50 border font-roboto font-normal text-black border-slate-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        {value.map((item: any, index: number) => (
          <div className=" flex-col">
            <div key={index} className="flex items-center mb-2">
              <span className="mr-2">{index + 1}.</span>
              <input
                type="text"
                className="border rounded-md border-slate-300 p-1 flex-1"
                value={item.text}
                onChange={(e) => handleChange(index, "text", e.target.value)}
                placeholder="Text"
              />
              <select
                value={item.language}
                onChange={(e) => handleSelectLang(index, e.target.value)}
                className="bg-gray-50 border border-slate-300 text-gray-900 text-sm rounded-lg p-1 ml-2 outline-none"
              >
                <option value="">Select Language</option>
                {languages?.map((elm: any) => (
                  <option key={elm.code} value={elm.code}>
                    {elm.name}
                  </option>
                ))}
              </select>
              <button
                onClick={() => handleRemove(index)}
                type="button"
                className="ml-2 px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none"
              >
                Remove
              </button>
            </div>
            {error?.[index]?.text && touched?.[index]?.text && (
              <div className="text-red-500 text-sm mt-1">
                {error[index].text}
              </div>
            )}
            {error?.[index]?.language && touched?.[index]?.language && (
              <div className="text-red-500 text-sm mt-1">
                {error[index].language}
              </div>
            )}
          </div>
        ))}

        <button
          type="button"
          onClick={handleAdd}
          className="px-2 py-1 bg-lightaqua border-2 mt-2 font-roboto font-normal cursor-pointer"
        >
          + Add More Languages
        </button>
      </div>
      {error && typeof error === "string" && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
};

export const validateMultilingualData = (values: any) => {
  const { question, answer, filterName } = values;
  // Get all unique languages
  const languages = new Set();
  question.forEach((q: any) => languages.add(q.language));
  answer.forEach((a: any) => languages.add(a.language));
  filterName.forEach((f: any) => languages.add(f.language));

  const languagesArray = Array.from(languages);
  for (const lang of languagesArray) {
    const hasQuestion = question.some((q: any) => q.language === lang);
    const hasAnswer = answer.some((a: any) => a.language === lang);
    const hasFilterName = filterName.some((f: any) => f.language === lang);

    if (!hasQuestion || !hasAnswer || !hasFilterName) {
      return false; // Validation failed
    }
  }

  return true; // Validation passed
};

// eslint-disable-next-line no-undef
export type LanguageKey = keyof typeof languageFlags;
